
import React, {FC} from 'react';

import {columns} from './configs';

const Header: FC = () => {
	return (
		<thead>
			<tr>
				{columns.map((c, i) => (
					<th key={i}>
						{c.title}
					</th>
				))}
			</tr>
		</thead>
	);
};

export default Header;
